<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Notificaciones - Configuración</h4>
            <div class="small text-muted">Configuración de los medios de notificaciones disponibles</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer" no-body>
        <b-row>
          <b-col>      
            <b-tabs v-model="tabIndex" card>
              
              <b-tab title="Email" :title-link-class="linkClass(0)">
                <b-card-text>
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-3">
                      Email                      
                      <small>
                        <b-badge variant="success" v-if="crud.email.active">ACTIVO</b-badge>
                        <b-badge variant="danger" v-else>INACTIVO</b-badge>
                      </small>
                    </h5>                      
                  </div>
                  
                  <b-row>
                    <b-col md="6" sm="12">
                      <b-row>
                        <b-col md="6">
                          <b-form-group label="Servidor">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="crud.email.host"                               
                                          placeholder="mail.example.com">
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group label="Puerto">
                            <b-form-input type="number"
                                          size="sm"
                                          v-model="crud.email.port"                               
                                          placeholder="25">
                            </b-form-input>
                          </b-form-group>
                        </b-col> 
                        
                        <b-col md="3">
                          <b-form-group label="Cifrado">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="crud.email.encryption"                               
                                          placeholder="tls">
                            </b-form-input>
                          </b-form-group>
                        </b-col> 

                        <b-col md="6">
                          <b-form-group label="Usuario">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="crud.email.username"                               
                                          placeholder="example@example.com">
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group label="Contraseña">
                            <b-input-group class="w-100">                      
                              <b-form-input :type="password.typePassword"
                                            size="sm"
                                            v-model="crud.email.password"                               
                                            placeholder="*******">
                              </b-form-input>
                              <b-input-group-append>
                                <b-button variant="secondary" size="sm" @click="changeTypePassword()">
                                  <i class="icon material-icons">{{password.iconPassword}}</i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col> 
                        
                        <b-col md="6">
                          <b-form-group label="Nombre Remitente">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="crud.email.fromName"                               
                                          placeholder="example">
                            </b-form-input>
                          </b-form-group>
                        </b-col> 

                        <b-col md="6">
                          <b-form-group label="Email Remitente">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="crud.email.fromAddress"                               
                                          placeholder="example@example.com">
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      
                      <b-row>
                        <b-col md="12">                          
                          <b-button variant="dark" size="sm" @click="saveEmail()">Guardar</b-button>                        
                        </b-col>
                      </b-row>

                      <b-row>  
                        <b-col md="12">
                          <hr>
                        </b-col> 
                        
                        <b-col md="12">
                          <b-form-group label="Email de Prueba">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="crud.email.emailTest"                               
                                          placeholder="Ingrese un email para enviar la prueba">
                            </b-form-input>
                          </b-form-group>
                        </b-col> 
                      </b-row>
                      <b-row>
                        <b-col md="12" class="mb-2">
                          <b-button variant="secondary" size="sm" @click="testEmail()">Probar Conexión</b-button>                          
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6" sm="12">
                      <b-card bg-variant="light" header="Implementación" text-variant="dark">
                        <b-card-text>
                          Esta configuración es el servidor <b>SMTP</b> que el sistema usa para enviar todos los emails salientes:
                          alertas automáticas, envíos manuales, recuperación de contraseña, etc.

                          <hr>

                          <b>Qué proveedor usar</b>
                          <p class="mb-2">
                            Lo recomendable es un servicio de email transaccional (pensado para notificaciones de aplicaciones, no para
                            marketing), ya que mejora la entregabilidad y da estadísticas de envío:
                          </p>
                          <ul class="pl-3 mb-2">
                            <li><a href="https://mailgun.com" target="_blank">Mailgun</a> — buen volumen gratuito, fácil de configurar.</li>
                            <li><a href="https://mailtrap.io" target="_blank">Mailtrap</a> — ideal para probar en desarrollo sin mandar emails reales.</li>
                            <li><a href="https://sendgrid.com/" target="_blank">Sendgrid</a> — alternativa robusta, muy usada en producción.</li>
                          </ul>
                          <p class="mb-0">
                            También podés usar el servicio que te brinde tu proveedor de correo corporativo (Gmail/Google Workspace,
                            Microsoft 365, cPanel, etc.), siempre que te habilite el acceso SMTP.
                          </p>

                          <hr>

                          <b>Cómo completar los datos</b>
                          <ul class="pl-3 mb-2">
                            <li><b>Servidor</b>: el host SMTP que te da el proveedor (ej. <code>smtp.mailgun.org</code>).</li>
                            <li><b>Puerto</b> y <b>Cifrado</b> van de la mano: <code>587</code> con <code>tls</code> (lo más común), <code>465</code> con <code>ssl</code>, o <code>25</code> sin cifrado (no recomendado).</li>
                            <li><b>Usuario</b> y <b>Contraseña</b>: las credenciales SMTP que te da el proveedor (no siempre son el email real).</li>
                            <li><b>Nombre Remitente</b> y <b>Email Remitente</b>: cómo va a ver el destinatario el email en su bandeja de entrada.</li>
                          </ul>

                          <hr>

                          Después de guardar, usá <b>Probar Conexión</b> con un email de prueba antes de dar por buena la configuración —
                          así confirmás que los datos SMTP son correctos sin depender de que llegue un envío real del sistema.
                        </b-card-text>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>

              <b-tab title="Push" :title-link-class="linkClass(1)">
                <b-card-text>
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-3">
                      PUSH
                      <small>
                        <b-badge variant="success" v-if="crud.push.active">ACTIVO</b-badge>
                        <b-badge variant="danger" v-else>INACTIVO</b-badge>
                      </small>
                    </h5>
                  </div>

                  <b-row>
                    <b-col md="6" sm="12">
                      <b-row>

                        <b-col md="12">
                          <b-form-group label="VAPID Public Key">
                            <div class="vapid-key-chip" :class="{ 'vapid-key-chip--empty': !crud.push.vapidPublicKey }">
                              <b-icon icon="key-fill" class="vapid-key-chip__icon"></b-icon>
                              <span>{{ crud.push.vapidPublicKey || 'Se autogenera al crear la configuración' }}</span>
                            </div>
                          </b-form-group>
                        </b-col>
                        <b-col md="12">
                          <b-form-group label="VAPID Private Key">
                            <div class="vapid-key-chip" :class="{ 'vapid-key-chip--empty': !crud.push.vapidPrivateKey }">
                              <b-icon icon="lock-fill" class="vapid-key-chip__icon"></b-icon>
                              <span>{{ crud.push.vapidPrivateKey || 'Se autogenera al crear la configuración' }}</span>
                            </div>
                          </b-form-group>
                        </b-col>
                        <b-col md="12">
                          <b-form-group label="Subject (mailto: o URL de contacto)">
                            <b-form-input type="text"
                                          size="sm"
                                          v-model="crud.push.subject"
                                          placeholder="mailto:contacto@empresa.com">
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col md="12">
                          <b-button variant="dark" size="sm" @click="savePush()">Guardar</b-button>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col md="12">
                          <hr>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12" class="mb-2">
                          <b-button variant="secondary" size="sm" @click="testPush()">Probar Conexión</b-button>
                          <b-button variant="outline-danger" size="sm" @click="regeneratePush()">Regenerar claves</b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6" sm="12">
                      <b-card bg-variant="light" header="Implementación" text-variant="dark">
                        <b-card-text>
                          Las notificaciones Push se implementan mediante el estándar
                          <b>Web Push</b> nativo del navegador, autenticado con claves <b>VAPID</b>.
                          <br><br>
                          No requiere configurar ningún proyecto externo:
                          <ul>
                            <li>Las claves VAPID se <b>autogeneran</b> al crear la configuración inicial.</li>
                            <li>El campo <b>Subject</b> es un contacto de referencia (mailto: o URL) exigido por el estándar VAPID, para que los proveedores de push puedan contactar al emisor ante abuso.</li>
                            <li>Usá <b>Regenerar claves</b> solo si sospechás que la clave privada quedó expuesta: invalida todas las suscripciones existentes y los usuarios deben volver a aceptar las notificaciones.</li>
                          </ul>
                        </b-card-text>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>

              <b-tab title="Interna" :title-link-class="linkClass(2)">
                <b-card-text>
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-3">
                      Interna
                      <small><b-badge variant="success">ACTIVO</b-badge></small>
                    </h5>
                  </div>

                  <b-row>
                    <b-col md="6" sm="12">
                      <b-alert show variant="info">
                        <b-icon icon="info-circle" class="mr-1"></b-icon>
                        Este canal no requiere ninguna configuración: funciona siempre, para todos los usuarios con acceso al sistema.
                      </b-alert>
                    </b-col>
                    <b-col md="6" sm="12">
                      <b-card bg-variant="light" header="¿Cómo funciona?" text-variant="dark">
                        <b-card-text>
                          A diferencia de Email, Push o Whatsapp, la notificación <b>Interna no sale del sistema</b>: se guarda directamente
                          en la base de datos, asociada al usuario destinatario (staff, cliente o proveedor con acceso al sistema).

                          <hr>

                          <ul class="pl-3 mb-2">
                            <li>El usuario la ve dentro del sistema, en su pantalla de <b>"Mis Notificaciones"</b>, apenas inicia sesión.</li>
                            <li>Puede marcarla como leída, archivarla o restaurarla desde ahí.</li>
                            <li>No requiere que el usuario tenga email, teléfono ni haya aceptado permisos del navegador — solo necesita una cuenta activa en el sistema.</li>
                          </ul>

                          <b-alert show variant="warning" class="py-2 px-3 small mb-0">
                            <b-icon icon="exclamation-triangle" class="mr-1"></b-icon>
                            Su límite es justamente ese: si el usuario no ingresa al sistema, no se entera. Para avisos urgentes conviene
                            combinarla con Email, Push o Whatsapp.
                          </b-alert>
                        </b-card-text>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>

              <b-tab title="Whatsapp" :title-link-class="linkClass(3)">
                  <tab-whatsapp></tab-whatsapp>
              </b-tab>

              <b-tab title="SMS" :title-link-class="linkClassDanger(4)">
                <b-card-text>
                  <b-alert show variant="danger">
                    <b-icon icon="exclamation-triangle-fill" class="mr-1"></b-icon>
                    <b>Sin soporte.</b> El canal SMS ya no está soportado y no puede configurarse. Esta pestaña se mantiene únicamente a modo informativo.
                  </b-alert>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import TabWhatsapp from './settings/crudWhatsapp'

  export default {
    components: {
      TabWhatsapp,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'configuration',
          elements: {}
        }, 
        crud: {
          email: {
            id: 1,
            host: '',
            port: 0,
            encryption: '',
            username: '',
            password: '',
            fromName: '',
            fromAddress: '',
            emailTest: '',
            active: false,
          },   
          sms: {
            id: 1,            
            username: '',
            password: '',
            nroTest: '',
            active: false,
          },      
          push: {
            id: 1,
            vapidPublicKey: '',
            vapidPrivateKey: '',
            subject: '',
            active: false,
          }
        },  
        password: {
          typePassword: 'password',
          iconPassword: 'visibility',
        },
        tabIndex: 0     
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    }, 
    mounted () {
      this.showEmail()
      this.showPush()
    },
    methods: {
      linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['bg-primary', 'text-light']
        } else {
          return ['bg-light', 'text-info']
        }
      },
      linkClassDanger(idx) {
        if (this.tabIndex === idx) {
          return ['bg-danger', 'text-light']
        } else {
          return ['bg-light', 'text-danger']
        }
      },

      showEmail() {        
        var result = serviceAPI.showEmail(this.crud.email)

        result.then((response) => {
          var data = response.data
          
          this.crud.email.host = data.host_smtp
          this.crud.email.port = data.port_smtp
          this.crud.email.encryption = data.encryption          
          this.crud.email.username = data.username
          this.crud.email.password = data.password
          this.crud.email.fromName = data.from_name
          this.crud.email.fromAddress = data.from_address          
          this.crud.email.active = data.active          
        })
      },
      saveEmail() {
        this.$bvModal.msgBoxConfirm('¿Guardar datos de email?', {
          title: 'Guardar Email',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.saveEmail(this.crud.email);

            result.then((response) => {          
              loader.hide()          
              this.showEmail()
              this.$awn.success("Datos de email guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            }) 
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      
      testEmail() {

        var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$")
        if (!expreg.test(this.crud.email.emailTest)) {          
          this.$awn.alert("No se puede realizar el test sino se ingresa un email válido")          
          return false
        }

        this.$bvModal.msgBoxConfirm('¿Probar configuración de email?', {
          title: 'Configuración de email',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'PROBAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.testEmail(this.crud.email)

            result.then((response) => {               
              loader.hide()
              this.showEmail()
              this.$awn.success('Conexión en funcionamiento!!')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      

      showSMS() {        
        var result = serviceAPI.showSMS(this.crud.sms)

        result.then((response) => {
          var data = response.data
                              
          this.crud.sms.username = data.username
          this.crud.sms.password = data.password
          this.crud.sms.active = data.active          
        })
      },   
      saveSMS() {
        this.$bvModal.msgBoxConfirm('¿Guardar datos de sms?', {
          title: 'Guardar SMS',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.saveSMS(this.crud.sms);

            result.then((response) => {          
              loader.hide()          
              this.showSMS()
              this.$awn.success("Datos de SMS guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            }) 
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },               
      testSMS() {        
        if(this.crud.sms.nroTest.length != 10) {
          this.$awn.alert("No se puede realizar el test sino se ingresa un nro de teléfono válido")
          return false
        }

        this.$bvModal.msgBoxConfirm('¿Probar configuración de SMS?', {
          title: 'Configuración de SMS',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'PROBAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {        
            let loader = this.$loading.show();
            var result = serviceAPI.testSMS(this.crud.sms)

            result.then((response) => {               
              loader.hide()
              this.showSMS()
              this.$awn.success('Conexión en funcionamiento!!')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },     

      changeTypePassword() {
        if (this.password.typePassword === 'password') {
          this.password.typePassword = 'text'
          this.password.iconPassword = 'visibility_off'
        } else {
          this.password.typePassword = 'password'
          this.password.iconPassword  = 'visibility'
        }
      }, 
      
      showPush() {        
        var result = serviceAPI.showPush(this.crud.push)

        result.then((response) => {
          var data = response.data

          this.crud.push.vapidPublicKey = data.vapidPublicKey
          this.crud.push.vapidPrivateKey = data.vapidPrivateKey
          this.crud.push.subject = data.subject
          this.crud.push.active = data.active
        })
      },
      savePush() {
        this.$bvModal.msgBoxConfirm('¿Guardar datos de Notificaciones Push?', {
          title: 'Guardar Notificaciones Push',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.savePush(this.crud.push);

            result.then((response) => {          
              loader.hide()          
              this.showPush()
              this.$awn.success("Datos de Notificaciones Push guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            }) 
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      
      testPush() {        
        this.$bvModal.msgBoxConfirm('¿Probar configuración de Notificaciones Push?', {
          title: 'Configuración de Notificaciones Push',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'PROBAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.testPush(this.crud.push)

            result.then((response) => {               
              loader.hide()
              this.showPush()
              this.$awn.success('Conexión en funcionamiento!!')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
      },
      regeneratePush() {
        this.$bvModal.msgBoxConfirm('Esto invalida las suscripciones actuales: los usuarios van a tener que volver a habilitar las notificaciones. ¿Regenerar las claves VAPID?', {
          title: 'Regenerar claves VAPID',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'REGENERAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.regeneratePush(this.crud.push)

            result.then((response) => {
              loader.hide()
              this.showPush()
              this.$awn.success('Claves VAPID regeneradas con éxito')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
      },
    }
  }
</script>

<style scoped>
  .vapid-key-chip {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 7px 12px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.85rem;
    color: #495057;
    overflow-wrap: anywhere;
  }
  .vapid-key-chip__icon {
    flex-shrink: 0;
    color: #adb5bd;
  }
  .vapid-key-chip--empty {
    font-family: inherit;
    font-style: italic;
    color: #adb5bd;
  }
</style>